export default __webpack_public_path__ + "static/media/15.a71f007b.webp";